// extracted by mini-css-extract-plugin
module.exports = {"box":"box--3RTRM","products":"products--3V5Jk","list":"list--3BAD8","info":"info--3G8wu","onlyHeight":"onlyHeight--1tEx-","onlyLink":"onlyLink--2rBtp"};